<template>
  <v-container fluid dark class="mt-10 mb-12" :style="'overflow-y: scroll; max-height: 100%;'">
    <v-card dark>
      <v-container fluid>
        <v-row class="mt-4" v-if="method == ''">
          <v-col cols="12" class="d-flex justify-center">
            <span class="text-h5 text-center">Wybierz metodę płatności &nbsp;<v-icon
                :style="'transform: translateY(-3px)'">fas fa-money-check-alt</v-icon></span>
          </v-col>
          <v-col cols="12" v-show="$store.state.paymentMethods.includes('btc')">
            <v-divider class="mt-4 mb-4"></v-divider>

            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setPaymentMethod('btc')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/rrbtc.png" :style="'max-width: 200px; height: auto;'"> </v-img>
                </v-card>
              </v-col>
              <v-col class="
                    d-flex
                    justify-lg-start justify-md-start
                    align-center
                    justify-center
                    text-center
                  ">
                <span class="text-h6 text-center">Bitcoin</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4"></v-divider>
          </v-col>

          <v-col cols="12" v-show="$store.state.paymentMethods.includes('eth')">
            <v-divider class="mt-4 mb-4"></v-divider>

            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setPaymentMethod('eth')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/rreth.png" :style="'max-width: 200px; height: auto;'"> </v-img>
                </v-card>
              </v-col>
              <v-col class="
                    d-flex
                    justify-lg-start justify-md-start
                    align-center
                    justify-center
                    text-center
                  ">
                <span class="text-h6 text-center">Ethereum</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4"></v-divider>
          </v-col>

          <v-col cols="12" v-show="$store.state.paymentMethods.includes('transfer')">
            <v-divider class="mt-4 mb-4"></v-divider>

            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setPaymentMethod('transfer')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/rrblik.png" :style="'max-width: 200px; height: auto;'"> </v-img>
                </v-card>
              </v-col>
              <v-col class="
                    d-flex
                    justify-lg-start justify-md-start
                    align-center
                    justify-center
                    text-center
                  ">
                <span class="text-h6 text-center">Przelew na konto/BLIK</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4"></v-divider>
          </v-col>

          <v-col cols="12" v-show="false">
            <v-row class="d-flex justify-center" :style="'cursor: pointer;'" @click="setPaymentMethod('psc')">
              <v-col class="d-flex justify-lg-end justify-md-end justify-center">
                <v-card dark>
                  <v-img src="../assets/psc-rich.png" :style="'max-width: 200px; height: auto;'">
                  </v-img>
                </v-card>
              </v-col>
              <v-col class="
                    d-flex
                    justify-lg-start justify-md-start
                    align-center
                    justify-center
                    text-center
                  ">
                <span class="text-h6 text-center">Paysafecard</span>
              </v-col>
            </v-row>
            <v-divider class="mt-4 mb-4"></v-divider>
          </v-col>
        </v-row>

      </v-container>
    </v-card>

  </v-container>
</template>
  
<script>
export default {
  name: "PaymentOptionsView",
  data: () => ({
    method: ""
  }),
  created: function () {
    if (this.$store.getters.cartSize < 1) {
      this.$router.push("/koszyk");
    }
    // if (!this.$store.state.PSC)
    // {
    //   this.$store.commit("setPaymentMethod",'btc');
    //   this.$router.push("/podsumowanie");
    // }
  },
  methods: {
    goToCart: function () {
      this.$router.push("/koszyk");
    },
    goToProducts: function () {
      this.$router.push("/produkty");
    },
    setPaymentMethod: function (method) {
      this.$store.commit("setPaymentMethod", method);
      this.$router.push("/podsumowanie");
    },
  },
  components: {},
};
</script>
  
<style>
.bg-transparent {
  background-color: transparent !important;
}
</style>
  